import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Form, Row, Col, Spinner, Card, Badge, Nav } from "react-bootstrap";
import useMediaQuery from "../../hooks/useMediaQuery";
import CustomCalendar from "../../components/CustomCalendar/CustomCalendar";
import moment from "moment";
import 'moment/locale/it';
import CustomModal from "../../components/CustomModal/CustomModal";
import ComebackArrow from "../../components/ComebackArrow/ComebackArrow";
import { alertService } from '../../services/AlertService';
import useEsami from "../../hooks/useEsami";
import useCorsiUtenti from "../../hooks/useCorsiUtenti";
import useEsamiUtenti from "../../hooks/useEsamiUtenti";
import EsamiUtentiService from '../../services/EsamiUtentiService/EsamiUtentiService';
import CustomButton from "../../components/CustomButton/CustomButton";
import useClassiUtenti from "../../hooks/useClassiUtenti";
import { TIPO_CORSO } from "../../model/tipoCorso";
import useAttestati from "../../hooks/useAttestati";
import SelectRecipientModal from '../../components/SelectRecipientModal/SelectRecipientModal';
import useUtenti from "../../hooks/useUtenti"; 
import InputUserinfo from "../../components/InputUserInfo/InputUserInfo";
import EsamiService from '../../services/EsamiService/EsamiService';

const MODAL_TYPES = {
  NEW: 'NEW',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
  DELETE: 'DELETE',
  MANAGE_USERS: 'MANAGE_USERS',
  USER_DETAIL: 'USER_DETAIL'
};

export default function EsamiConfigPage() {
  
  const { modalStateUtenti, setModalStateUtenti } = useUtenti();
  const { getEsamiByIdClasse, createEsame, deleteEsame, updateEsame, loadingStateEsami } = useEsami();
  const { downloadAttestato, loadingStateAttestati, modalStateAttestati, setModalStateAttestati, aggiornaSpedizioneAttestato, stampaBustaAttestato } = useAttestati();
  const { updateEsameUtente, loadingStateEsamiUtenti, enterJoinroomAdmin } = useEsamiUtenti();
  const [userForEnvelopePrint, setUserForEnvelopePrint] = useState(null);
  const [selectedSoggettoForPrint, setSelectedSoggettoForPrint] = useState('corsista');
  const { getClassiUtentiByIdClasse } = useClassiUtenti();

  const location = useLocation();
  const navigate = useNavigate();
  const classe = location.state?.classeData;
  const isWideScreen = useMediaQuery("(min-width: 1200px)");
  const [exams, setExams] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newExam, setNewExam] = useState({ data: "", ora_inizio: "", ora_fine: "" });
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingExamId, setEditingExamId] = useState(null);
  const [modalMode, setModalMode] = useState(MODAL_TYPES.NEW);

  const [corsoUtenti, setCorsoUtenti] = useState([]);
  const [selectedExamUsers, setSelectedExamUsers] = useState([]);
  const userPrenotato = newExam?.utenti?.find(u => u.prenotato);

  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [examCountdowns, setExamCountdowns] = useState({});
  const [selectedUtenteForEdit, setSelectedUtenteForEdit] = useState(null);

  const [creationType, setCreationType] = useState('single'); 
  const [numeroPosti, setNumeroPosti] = useState(1);

  const [selectedUser, setSelectedUser] = useState(null);

  const [docentiEsaminatori, setDocentiEsaminatori] = useState([]); 
  const [selectedDocenteId, setSelectedDocenteId] = useState("");   
  const [isLoadingDocenti, setIsLoadingDocenti] = useState(false);  

  const [sendNotification, setSendNotification] = useState(true); // Default true: invia sempre

  useEffect(() => {
    if (!classe?.id_classe) {
      console.warn("useEffect: Dati classe mancanti o incompleti. Navigazione..."); 
      if (classe?.corso?.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA) {
        navigate("/gestione-corsi");
      } else {
        navigate("/gestione-classi");
      }
      return; 
    }
    fetchExams();
    if (classe?.corso?.modalita_erogazione !== TIPO_CORSO.TELEMATICA_ASINCRONA) {
      fetchCorsoUtenti();
    }
  }, [classe, navigate]); 

  const loadDocentiForSession = async (idCorso) => {
    if (!idCorso) return;
    setIsLoadingDocenti(true);
    try {
      const response = await EsamiService.getDocentiAbilitatiPerCorso({ id_corso: idCorso });
      if (response && Array.isArray(response)) {
        setDocentiEsaminatori(response);
      } else {
        setDocentiEsaminatori([]);
      }
    } catch (error) {
      console.error("Errore caricamento docenti", error);
    } finally {
      setIsLoadingDocenti(false);
    }
  };

  useEffect(() => {
      if (showModal && modalMode === MODAL_TYPES.VIEW && classe?.corso?.id_corso) {
          loadDocentiForSession(classe.corso.id_corso);
          setSelectedDocenteId(""); 
      }
  }, [showModal, modalMode, classe?.corso?.id_corso]);

  const fetchExams = async () => {
    if (classe?.id_classe) {
      const obj = { id_classe: classe.id_classe };
      try {
        const fetchedExams = await getEsamiByIdClasse(obj); 
       
        if (Array.isArray(fetchedExams)) {
          const formattedExamsForState = fetchedExams.map(examBE => {
            const utenteData = (examBE.utenti && examBE.utenti.length > 0) ? examBE.utenti[0] : null;
            const isMultiplo = examBE.is_multiplo;

            return {
              id_calendario_esame: examBE.id_calendario_esame,
              id_corso: examBE.id_corso,
              data: examBE.data?.split(' ')[0],
              ora_inizio: examBE.ora_inizio,
              ora_fine: examBE.ora_fine,
              
              is_multiplo: isMultiplo, 
              max_parts: examBE.max_parts,     
              is_concluso: examBE.is_concluso, 
              data_concluso: examBE.data_concluso,

              id_classe_utente: utenteData?.id_classe_utente,
              esito_esame: utenteData?.esito_esame,
              stato_pagamento: utenteData?.stato_pagamento,     
              pagamento_partner: utenteData?.pagamento_partner, 
              id_attestato: utenteData?.id_attestato,
              soggetto_spedizione: utenteData?.soggetto_spedizione,
              abilitato_ripetizione: utenteData?.abilitato_ripetizione,

              // --- CORREZIONE: Popola resource SOLO se NON è multiplo ---
              resource: (isMultiplo == 0 && utenteData) ? {
                  id_utente: utenteData.id_utente,
                  nome: utenteData.nome,
                  cognome: utenteData.cognome,
                  id_agenzia: utenteData.id_agenzia,
                  luogo_nascita: utenteData.luogo_nascita,
                  data_nascita: utenteData.data_nascita,
                  path_documento: utenteData.path_documento, 
                  path_codicefiscale: utenteData.path_codicefiscale, 
                  path_documento_retro: utenteData.path_documento_retro, 
                  path_codicefiscale_retro: utenteData.path_codicefiscale_retro, 
                  provincia_nascita: utenteData.provincia_nascita, 
                  telefono1: utenteData.telefono1,             
                  telefono2: utenteData.telefono2,
                  abilitato_ripetizione: utenteData.abilitato_ripetizione,
                  esito_esame: utenteData.esito_esame
              } : null,

              utenti: examBE.utenti || []
            };
          });

          setExams(formattedExamsForState); 
        } else {
          setExams([]);
        }
      } catch (error) {
           console.error("ERRORE in fetchExams:", error);
           setExams([]);
      }
    }
  };

    const fetchCorsoUtenti = async () => {
      if (classe?.corso?.id_corso) {
        const fetchedCorsoUtenti = await getClassiUtentiByIdClasse({ id_classe: classe.id_classe });
        const corsisti = fetchedCorsoUtenti.filter(utente => utente.tipo_utente === 'corsista');
        setCorsoUtenti(corsisti);
      }
    };

    const minDate = classe?.data_fine ? moment(classe.data_fine, "YYYY-MM-DD HH:mm:ss").toDate() : new Date();

    useEffect(() => { moment.locale('it'); }, []);

  const formatDate = (date) => {
    if (!date) return '';
    const momentDate = moment(date);
    return momentDate.format('dddd D MMMM YYYY').replace(/^\w/, (c) => c.toUpperCase());
  };

  const openEditUserModal = (utente) => {
    if (!utente) return;
    setSelectedUtenteForEdit(utente); 
    setModalStateUtenti((prev) => ({ ...prev, showModalUpdateUtente: true }));
    setShowModal(false); 
  };

  const getFontePagamentoText = (pagamentoPartnerValue) => {
        switch (parseInt(pagamentoPartnerValue, 10)) { 
            case 1: return 'Corsista';
            case 2: return 'Partner';
            case 3: return 'Superpartner';
            case 0:
            default: return 'Non Assegnato'; 
        }
    };

  const handleCloseEditUserModal = () => {
    setModalStateUtenti((prev) => ({ ...prev, showModalUpdateUtente: false }));
    setSelectedUtenteForEdit(null); 
  };

  const handleSelectSlot = (slotInfo) => {
    const data = moment(slotInfo.start).format("YYYY-MM-DD");
    const ora_inizio = moment(slotInfo.start).format("HH:mm");
    const ora_fine = moment(slotInfo.end).format("HH:mm");
    setNewExam({ data, ora_inizio, ora_fine });
    setIsEditMode(false);
    setEditingExamId(null);
    setModalMode(MODAL_TYPES.NEW);
    setShowModal(true);
  };

  const handleUserClick = (e, user, exam) => {
    e.stopPropagation(); 
    e.preventDefault();

    const userExamData = {
        ...exam,           
        ...user,           
        resource: user     
    };

    setNewExam(userExamData); 
    setSelectedUser(user); 
    setModalMode(MODAL_TYPES.USER_DETAIL); 
    setShowModal(true);
  };

  const handleSelectEvent = (event) => {
    const fullExam = exams.find(e => e.id_calendario_esame === event.id_calendario_esame);
    if (!fullExam) return;

    // --- CORREZIONE: Se gruppo, risorsa NULL ---
    const isMultiplo = fullExam.is_multiplo == 1 || (fullExam.max_parts && fullExam.max_parts > 1);
    const resourceToUse = isMultiplo ? null : (event.resource || fullExam.resource);

    const payload = {
      ...fullExam, 
      start: event.start,
      end: event.end,
      resource: resourceToUse,
    };

    setNewExam(payload);
    setEditingExamId(event.id_calendario_esame);
    setIsEditMode(true);
    setModalMode(MODAL_TYPES.VIEW);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setNewExam({ data: "", ora_inizio: "", ora_fine: "" });
    setIsEditMode(false);
    setEditingExamId(null);
    setModalMode(MODAL_TYPES.NEW);
    setCreationType('single');
    setNumeroPosti(1);
    setSelectedUser(null); // --- CORREZIONE: Reset user ---
    setSendNotification(true); // Reset a true
  };

  const handleSaveExam = async () => {
    if (newExam.ora_fine <= newExam.ora_inizio) {
      alertService.warn("L'ora di fine deve essere successiva all'ora di inizio", { autoClose: true });
      return;
    }

    const isMultiplo = creationType === 'multiple' ? 1 : 0;
    const maxParts = creationType === 'multiple' ? numeroPosti : 1;

    const baseExamData = {
      id_corso: classe?.corso.id_corso,
      id_classe: classe?.id_classe,
      data: newExam?.data,
      ora_inizio: newExam?.ora_inizio,
      ora_fine: newExam?.ora_fine,
      is_multiplo: isMultiplo,
      max_parts: maxParts,
      invia_notifica: sendNotification ? 1 : 0
    };

    try {
      if (isEditMode) {
        const examData = { ...baseExamData, id_calendario_esame: editingExamId };
        const updatedExam = await updateEsame(examData);
        if (updatedExam === -1) {
          alertService.warn("Esiste già un esame previsto all'interno di questa fascia oraria.", { autoClose: true });
        } else {
          await fetchExams();
        }
      } else {
        const createdExam = await createEsame(baseExamData);
        if (createdExam === -1) {
          alertService.warn("Esiste già un esame previsto all'interno di questa fascia oraria.", { autoClose: true });
        } else {
          const msg = isMultiplo 
            ? `Sessione di gruppo (${maxParts} posti) creata con successo.` 
            : "Esame singolo creato con successo.";
          alertService.success(msg, { autoClose: true });
          await fetchExams();
        }
      }
    } catch (error) {
      console.error("Errore salvataggio esame", error);
      alertService.error("Errore imprevisto durante il salvataggio.");
    }
    handleCloseModal();
  };

  const handleEditClick = () => { setModalMode(MODAL_TYPES.EDIT); };
  const handleDeleteClick = () => { setModalMode(MODAL_TYPES.DELETE); };

  const handleDeleteExam = async () => {
    await deleteEsame({ id_esame: editingExamId });
    setExams(exams.filter(exam => exam.id_calendario_esame !== editingExamId));
    handleCloseModal();
  };

  const handleManageUsers = async (exam) => {
    setNewExam(exam);
    setSelectedExamUsers(exam.utenti || []);
    setModalMode(MODAL_TYPES.MANAGE_USERS);
  };

  const handleUserSelection = (user) => {
    setSelectedExamUsers(prev => 
      prev.some(u => u.id_utente === user.id_utente)
        ? prev.filter(u => u.id_utente !== user.id_utente)
        : [...prev, user]
    );
  };

  const handleSaveUserSelection = async () => {
      const obj = {
        id_calendario_esame: newExam.id_calendario_esame,
        utenti: selectedExamUsers
      }
      await updateEsameUtente(obj);
      handleCloseModal();
      fetchExams();
  };

  const handleConfirmCancelUserBooking = async () => {
    if (!userPrenotato) return;
    try {
      await EsamiUtentiService.deleteEsameUtente({
        id_esame_utente: userPrenotato.id_calendario_esame_utente
      });
      alertService.success("Prenotazione annullata con successo.", { autoClose: true });
      setShowConfirmDeleteModal(false);
      handleCloseModal();
      fetchExams();
    } catch (error) {
      alertService.error('Errore durante l\'annullamento della prenotazione.');
    }
  };

  useEffect(() => {
    updateCountdowns(); 
    const interval = setInterval(updateCountdowns, 1000);
    return () => clearInterval(interval);
  }, [exams]);
  
  const updateCountdowns = () => {
    const now = moment();
    const updatedCountdowns = {};
    exams.forEach(exam => {
      const start = moment(`${exam.data}T${exam.ora_inizio}`);
      const diffSeconds = start.diff(now, 'seconds');
      if (diffSeconds <= 0) {
        updatedCountdowns[exam.id_calendario_esame] = 'INIZIATO';
      } else if (diffSeconds <= 86400) {
        if (diffSeconds < 60) updatedCountdowns[exam.id_calendario_esame] = `Inizio tra ${diffSeconds} second${diffSeconds === 1 ? 'o' : 'i'}`;
        else if (diffSeconds < 3600) {
            const minutes = Math.floor(diffSeconds / 60);
            updatedCountdowns[exam.id_calendario_esame] = `Inizio tra ${minutes} minut${minutes === 1 ? 'o' : 'i'}`;
        } else {
            const duration = moment.duration(start.diff(now));
            const hours = duration.hours();
            const minutes = duration.minutes();
            updatedCountdowns[exam.id_calendario_esame] = `Inizio tra ${hours} or${hours === 1 ? 'a' : 'e'} e ${minutes} minut${minutes === 1 ? 'o' : 'i'}`;
        }
      }
    });
    setExamCountdowns(prev => {
      const changed = Object.keys(updatedCountdowns).some(key => updatedCountdowns[key] !== prev[key]);
      return changed ? updatedCountdowns : prev;
    });
  };

  const enterJoinRoom = async (id_calendario_esame, exam) => {
      try {
        let response;
        var id_utente = exam.utenti && exam.utenti.length > 0 ? exam.utenti[0].id_utente : null;
        if (!id_utente) { alertService.error("Dati utente mancanti."); return; }
        
        response = await enterJoinroomAdmin({ id_calendario_esame: id_calendario_esame, id_user: id_utente });
        const dataReale = Array.isArray(response) ? response[0] : (response.data && Array.isArray(response.data) ? response.data[0] : null);

        if (dataReale && dataReale.meeting_id) {
            handleJoinMeeting(dataReale.meeting_id, dataReale.enc_str);
        }
      } catch (error) {
        alertService.error('Errore durante l\'accesso alla Joinroom di esame.');
      }
    };
  
  const handleJoinMeeting = async (meeting_id ,  enc_str) => {
    const newWindow = window.open('', '_blank');
    newWindow.document.write('Caricamento della riunione in corso...');
    try {
      const meetingUrl = `https://www.jampink.com/jp-meeting/${meeting_id}?se=${enc_str}`;
      newWindow.location.href = meetingUrl;
    } catch (error) {
      console.error("Errore nel recupero dei dettagli della riunione:", error);
      newWindow.document.write('Impossibile caricare la riunione. Per favore, chiudi questa scheda e riprova.');
    }
  };

    const openSelectRecipientModal = (userData) => {
        setUserForEnvelopePrint(userData);
        setModalStateAttestati(prev => ({ ...prev, showSelectRecipientModal: true }));
        setShowModal(false); 
    };
    const handleCloseSelectRecipientModal = () => {
        setModalStateAttestati(prev => ({ ...prev, showSelectRecipientModal: false }));
        setUserForEnvelopePrint(null);
    };
    const handleSubjectChangeForPrint = (newSoggetto) => {
        setSelectedSoggettoForPrint(newSoggetto);
    };
    const handleConfirmRecipientAndPrint = async () => {
        if (!userForEnvelopePrint || !userForEnvelopePrint.id_attestato) return;
        const currentSelectedSoggetto = selectedSoggettoForPrint;
        const hasAgenzia = userForEnvelopePrint?.id_agenzia;
        if (currentSelectedSoggetto === 'agenzia' && !hasAgenzia) {
             alertService.warn("Il corsista non è associato a un'agenzia."); return;
         }
        const saveSuccess = await aggiornaSpedizioneAttestato({
            id_attestato: userForEnvelopePrint.id_attestato,
            soggetto_spedizione: currentSelectedSoggetto,
        });
        if (saveSuccess) {
            await stampaBustaAttestato({ id_attestato: userForEnvelopePrint.id_attestato });
            handleCloseSelectRecipientModal();
            fetchExams(); 
        }
    };

  const renderModalBody = () => {
    
    // --- FUNZIONE CENTRALIZZATA PER ABILITARE RIPETIZIONE ---
    const handleAbilitaRipetizione = async (idTarget, nomeTarget) => {
        if (!idTarget) {
            alertService.error("ID prenotazione non trovato.");
            return;
        }
        if (!window.confirm(`Sei sicuro di voler permettere a ${nomeTarget} di prenotarsi nuovamente?`)) return;
        try {
            await EsamiUtentiService.abilitaRipetizione({ id_calendario_esame_utente: idTarget });
            alertService.success("Corsista abilitato alla ripetizione.");
            await fetchExams(); 
            if (modalMode === MODAL_TYPES.USER_DETAIL) {
                setSelectedUser(prev => ({ ...prev, abilitato_ripetizione: 1 }));
            } else if (modalMode === MODAL_TYPES.VIEW) {
                setNewExam(prev => ({ 
                    ...prev, 
                    abilitato_ripetizione: 1, 
                    resource: { ...prev.resource, abilitato_ripetizione: 1 } 
                }));
            }
        } catch (error) {
            console.error(error);
            alertService.error("Errore durante l'abilitazione.");
        }
    };

    switch (modalMode) {
      case MODAL_TYPES.NEW:
        return (
          <Form>
            <Row className="mb-3">
              <Col xs={6}>
                <Form.Group>
                  <Form.Label><span className='text-muted'><b>Orario inizio</b></span></Form.Label>
                  <Form.Control type="time" value={newExam?.ora_inizio || ''} onChange={(e) => setNewExam({ ...newExam, ora_inizio: e.target.value })} />
                </Form.Group>
              </Col>
              <Col xs={6}>
                <Form.Group>
                  <Form.Label><span className='text-muted'><b>Orario fine</b></span></Form.Label>
                  <Form.Control type="time" value={newExam?.ora_fine || ''} onChange={(e) => setNewExam({ ...newExam, ora_fine: e.target.value })} />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3">
              <Form.Label><b>Tipologia Sessione</b></Form.Label>
              <div className="d-flex gap-3">
                <Form.Check type="radio" label="Esame Singolo" name="creationType" id="typeSingle" checked={creationType === 'single'} onChange={() => setCreationType('single')} />
                <Form.Check type="radio" label="Esame di Gruppo" name="creationType" id="typeMultiple" checked={creationType === 'multiple'} onChange={() => setCreationType('multiple')} />
              </div>
            </Form.Group>
            {creationType === 'multiple' && (
              <Form.Group className="mb-3">
                <Form.Label><b>Numero Posti Disponibili</b> <small className="text-muted">(Max 30)</small></Form.Label>
                <Form.Control type="number" min="2" max="30" value={numeroPosti} onChange={(e) => setNumeroPosti(Math.min(30, Math.max(2, parseInt(e.target.value) || 2)))} />
                <Form.Text className="text-muted">Verranno creati <b>{numeroPosti}</b> posti identici nello stesso orario.</Form.Text>
              </Form.Group>
            )}
            <hr className="my-3" />
            {/* NUOVA CHECKBOX NOTIFICA */}
            <Form.Group className="mb-3 bg-light p-2 rounded border">
                <Form.Check 
                    type="checkbox"
                    id="sendNotificationCheck"
                    label={
                        <span>
                            <i className="bi bi-envelope-check-fill text-success me-2"></i>
                            Invia email di avviso ai corsisti in attesa
                        </span>
                    }
                    checked={sendNotification}
                    onChange={(e) => setSendNotification(e.target.checked)}
                />
                <Form.Text className="text-muted small d-block ms-4">
                    Verrà inviata una mail a tutti i corsisti del corso che non hanno ancora superato l'esame e non hanno prenotazioni future attive.
                </Form.Text>
            </Form.Group>
          </Form>
        );

      case MODAL_TYPES.EDIT:
        return (
          <Form>
            <Row>
              <Col xs={6}>
                <Form.Group>
                  <Form.Label><span className='text-muted'><b>Orario inizio</b></span></Form.Label>
                  <Form.Control type="time" value={newExam?.ora_inizio || ''} onChange={(e) => setNewExam({ ...newExam, ora_inizio: e.target.value })} />
                </Form.Group>
              </Col>
              <Col xs={6}>
                <Form.Group>
                  <Form.Label><span className='text-muted'><b>Orario fine</b></span></Form.Label>
                  <Form.Control type="time" value={newExam?.ora_fine || ''} onChange={(e) => setNewExam({ ...newExam, ora_fine: e.target.value })} />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        );

      case MODAL_TYPES.VIEW:
        // Recuperiamo il corsista SOLO se già selezionato o presente in singolo
        const corsista = newExam?.resource || selectedUser;
        // È un gruppo SE: è multiplo E non c'è un corsista specifico selezionato
        const isGruppo = (newExam.is_multiplo == 1 || (newExam.max_parts && newExam.max_parts > 1)) && !corsista;
        
        const isConcluso = newExam.is_concluso == 1 || newExam.is_concluso === true;

        const handleCloseSession = async () => {
          if (!selectedDocenteId) { alertService.warn("Devi selezionare un Docente Esaminatore."); return; }
          if (!window.confirm("Sei sicuro di voler chiudere la sessione?")) return;
          try {
              await EsamiUtentiService.concludeSessione({ id_calendario_esame: newExam.id_calendario_esame, id_utente_esaminatore: selectedDocenteId });
              alertService.success("Sessione conclusa!");
              handleCloseModal();
              fetchExams(); 
          } catch (error) { console.error(error); alertService.error("Errore durante la chiusura."); }
        };

        const handleEditProfile = () => { if (corsista) openEditUserModal(corsista); };
        const handleDownloadAttestato = async () => {
            if (!newExam?.id_classe_utente) { alertService.error("ID mancante."); return; }
            await downloadAttestato({ id_classe_utente: newExam.id_classe_utente }, `attestato.pdf`);
        };

        // SCENARIO A: ESAME DI GRUPPO (Dashboard)
        if (isGruppo) {
            return (
                <div>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="mb-0"><i className="bi bi-people-fill me-2 text-primary"></i>Sessione di Gruppo</h5>
                        {isConcluso ? <span className="badge bg-success fs-6">CONCLUSA <i className="bi bi-check-all ms-1"></i></span> : <span className="badge bg-primary">APERTA</span>}
                    </div>
                    <p><i className="bi bi-calendar-event me-2 text-muted"></i>Data: {formatDate(newExam?.data)}</p>
                    <p><i className="bi bi-clock me-2 text-muted"></i>Orario: {newExam?.ora_inizio?.slice(0, 5)} - {newExam?.ora_fine?.slice(0, 5)}</p>
                    <div className="alert alert-light border d-flex justify-content-around align-items-center py-3 mb-3 text-center">
                        <div><h4 className="mb-0 text-primary">{newExam.utenti?.length || 0}</h4><small className="text-muted">Iscritti</small></div>
                        <div className="border-start mx-2 h-100"></div>
                        <div><h4 className="mb-0 text-secondary">{newExam.max_parts}</h4><small className="text-muted">Posti Totali</small></div>
                        <div className="border-start mx-2 h-100"></div>
                        <div><h4 className="mb-0 text-success">{newExam.utenti?.filter(u => u.esito_esame === 'promosso').length || 0}</h4><small className="text-muted">Promossi</small></div>
                    </div>
                    <hr />
                    {isConcluso ? (
                        <div className="text-center py-3">
                            <div className="alert alert-success mb-4"><i className="bi bi-info-circle-fill me-2"></i>Sessione chiusa il: <strong>{newExam.data_concluso ? moment(newExam.data_concluso).format('DD/MM/YYYY [alle] HH:mm') : 'Data non disponibile'}</strong></div>
                            <Button variant="success" size="lg" className="w-100 shadow" onClick={() => navigate("/gestione-risultati-esame", { state: { examData: newExam, classeData: classe } })}>
                                <i className="bi bi-card-checklist me-2"></i> VAI AI RISULTATI ESAME
                            </Button>
                        </div>
                    ) : (
                        <>
                            <h6 className="mb-3">Azioni Sessione:</h6>
                            <div className="row g-3">
                                <div className="col-md-12">
                                    <div className="card shadow-sm border-warning">
                                      <div className="card-body p-3">
                                          <div className="d-flex align-items-center justify-content-between mb-3"><div><h6 className="mb-1 text-warning"><i className="bi bi-stop-circle-fill me-2"></i>Chiusura Sessione</h6><small className="text-muted">Seleziona il docente e termina.</small></div></div>
                                          <Form.Group className="mb-3">
                                              <Form.Label className="small fw-bold text-muted">Docente Esaminatore *</Form.Label>
                                              <Form.Select value={selectedDocenteId} onChange={(e) => setSelectedDocenteId(e.target.value)} disabled={isLoadingDocenti} size="sm">
                                                  <option value="">-- Seleziona Docente --</option>
                                                  {docentiEsaminatori.map(doc => (<option key={doc.id_utente} value={doc.id_utente}>{doc.cognome} {doc.nome}</option>))}
                                              </Form.Select>
                                          </Form.Group>
                                          <Button variant="warning" className="w-100" onClick={handleCloseSession} disabled={!selectedDocenteId || isLoadingDocenti}>Concludi Ora</Button>
                                      </div>
                                  </div>
                                </div>
                                <div className="col-md-6"><Button variant="outline-info" className="w-100" onClick={handleEditClick}><i className="bi bi-pencil me-2"></i> Modifica Orario</Button></div>
                                <div className="col-md-6"><Button variant="outline-danger" className="w-100" onClick={handleDeleteClick} disabled={newExam.utenti && newExam.utenti.length > 0}><i className="bi bi-trash me-2"></i> Elimina Sessione</Button></div>
                            </div>
                            <div className="mt-4 pt-3 border-top"><small className="text-muted"><i className="bi bi-info-circle me-1"></i> Per gestire i singoli corsisti, clicca sul loro nome nella lista del calendario.</small></div>
                        </>
                    )}
                </div>
            );
        }

        // SCENARIO B: ESAME SINGOLO (Dettaglio)
        if (!corsista) {
            return (
                <div>
                    <p><i className="bi bi-calendar-event me-2 text-muted"></i>Data: {formatDate(newExam?.data)}</p>
                    <p><i className="bi bi-clock me-2 text-muted"></i>Orario: {newExam?.ora_inizio?.slice(0, 5)} - {newExam?.ora_fine?.slice(0, 5)}</p>
                    <p className="text-muted fst-italic">Nessun corsista prenotato.</p>
                    <hr />
                    <div className="d-grid gap-2 d-sm-flex">
                        <Button variant="outline-info" size="sm" onClick={handleEditClick}><i className="bi bi-pencil me-1"></i> Modifica</Button>
                        <Button variant="outline-danger" size="sm" onClick={handleDeleteClick}><i className="bi bi-trash me-1"></i> Elimina</Button>
                        {classe?.corso?.modalita_erogazione !== TIPO_CORSO.TELEMATICA_ASINCRONA && (
                              <Button variant="outline-primary" size="sm" onClick={() => handleManageUsers(newExam)}><i className="bi bi-people me-1"></i> Gestisci Abilitati</Button>
                        )}
                    </div>
                </div>
            );
        }

        const esito = newExam?.esito_esame || newExam.resource?.esito_esame;
        const haPassatoEsame = esito === 'promosso';
        const isBocciato = esito === 'bocciato' || esito === 'non_svolto';
        
        const abilitatoVal = newExam.abilitato_ripetizione !== undefined ? newExam.abilitato_ripetizione : newExam.resource?.abilitato_ripetizione;
        const isGiaAbilitato = abilitatoVal == 1;

        return (
          <div>
            <h5 className="mb-1">Corsista: <strong>{corsista.nome} {corsista.cognome}</strong></h5>
            <p className="mb-3">
                Esito: <span className={esito === 'promosso' ? 'text-success fw-bold ms-1' : (esito === 'bocciato' ? 'text-danger fw-bold ms-1' : ' ms-1')}>{esito ? esito.replace('_', ' ') : 'Non registrato'}</span>
                {isGiaAbilitato && isBocciato && <span className="badge bg-success ms-2"><i className="bi bi-check-circle me-1"></i>Ripetizione Abilitata</span>}
            </p>
            {newExam?.stato_pagamento === 'Pagato' && <p className="mb-3 fst-italic small"><i className="bi bi-wallet2 me-1 text-muted"></i> Pagato da: {getFontePagamentoText(newExam.pagamento_partner)}</p>}
            <p>Data: {formatDate(newExam.data)} | Orario: {newExam?.ora_inizio?.slice(0, 5)} - {newExam?.ora_fine?.slice(0, 5)}</p>
            <hr className="my-4"/>
            <div className="row g-3">
              {/* Pulsante Sblocca */}
              {isBocciato && !isGiaAbilitato && (
                  <div className="col-md-6"> 
                      <div className="card h-100 shadow-sm border-warning" style={{backgroundColor: '#fffcf5'}}> 
                          <div className="card-body d-flex flex-column align-items-center justify-content-center text-center"> 
                              <i className="bi bi-lock-fill fs-1 mb-2 text-warning"></i> 
                              <h6 className="card-title text-warning fw-bold">Gestione Bocciatura</h6> 
                              <Button variant="warning" size="sm" onClick={() => handleAbilitaRipetizione()} className="mt-1 text-dark fw-bold shadow-sm"> 
                                  <i className="bi bi-unlock-fill me-1"></i> Sblocca e Abilita
                              </Button> 
                          </div> 
                      </div> 
                  </div>
              )}
              {/* Altre Card */}
              <div className="col-md-6"> <div className="card h-100 shadow-sm"> <div className="card-body d-flex flex-column align-items-center justify-content-center text-center"> <i className="bi bi-clipboard-check fs-1 mb-2 text-success"></i> <h6 className="card-title">Risultati Esame</h6> <Button variant="outline-success" size="sm" onClick={() => navigate("/gestione-risultati-esame", { state: { examData: newExam, classeData: classe } })} className="mt-2"> <i className="bi bi-arrow-right-circle me-1"></i> Gestisci </Button> </div> </div> </div>
              <div className="col-md-6"> <div className="card h-100 shadow-sm"> <div className="card-body d-flex flex-column align-items-center justify-content-center text-center"> <i className="bi bi-person-gear fs-1 mb-2 text-primary"></i> <h6 className="card-title">Anagrafica Corsista</h6> <Button variant="outline-primary" size="sm" onClick={handleEditProfile} disabled={!corsista?.id_utente} className="mt-2"> <i className="bi bi-pencil-square me-1"></i> Modifica </Button> </div> </div> </div>
              {haPassatoEsame && ( <div className="col-md-6"> <div className="card h-100 shadow-sm"> <div className="card-body d-flex flex-column align-items-center justify-content-center text-center"> <i className="bi bi-file-earmark-arrow-down fs-1 mb-2 text-success"></i> <h6 className="card-title">Attestato</h6> <Button variant="outline-success" size="sm" onClick={handleDownloadAttestato} className="mt-2"> <i className="bi bi-printer me-1"></i> Stampa </Button> </div> </div> </div> )}
              <div className="col-md-6"> <div className="card h-100 shadow-sm"> <div className="card-body d-flex flex-column align-items-center justify-content-center text-center"> <i className="bi bi-clock-history fs-1 mb-2 text-info"></i> <h6 className="card-title">Modifica Orario Slot</h6> <Button variant="outline-info" size="sm" onClick={handleEditClick} className="mt-2"> <i className="bi bi-pencil me-1"></i> Modifica </Button> </div> </div> </div>
              <div className="col-md-6"> <div className="card h-100 shadow-sm"> <div className="card-body d-flex flex-column align-items-center justify-content-center text-center"> <i className="bi bi-trash fs-1 mb-2 text-danger"></i> <h6 className="card-title">Elimina Slot Esame</h6> <Button variant="outline-danger" size="sm" onClick={handleDeleteClick} className="mt-2"> <i className="bi bi-x-circle me-1"></i> Elimina </Button> </div> </div> </div>
            </div>
          </div>
        );

      // --- 4. DETTAGLIO UTENTE (CLIC DA GRUPPO) ---
      case MODAL_TYPES.USER_DETAIL:
        if (!selectedUser) return <div>Nessun utente selezionato.</div>;
        
        const handleResendEmail = async () => {
            if (!window.confirm(`Vuoi reinviare l'email di conferma a ${selectedUser.nome} ${selectedUser.cognome}?`)) return;
            try {
                await EsamiUtentiService.resendEmail({ id_calendario_esame: newExam.id_calendario_esame, id_utente: selectedUser.id_utente });
                alertService.success("Email inviata con successo!");
            } catch (error) { console.error(error); alertService.error("Errore invio email."); }
        };
        
        const handleEditProfileUser = () => { openEditUserModal(selectedUser); };
        const handleDownloadAttestatoUser = async () => {
            if (!selectedUser.id_classe_utente) { alertService.error("ID mancante."); return; }
            await downloadAttestato({ id_classe_utente: selectedUser.id_classe_utente }, `attestato.pdf`);
        };
        
        const haPassatoEsameUser = selectedUser.esito_esame === 'promosso';
        const isBocciatoUser = selectedUser.esito_esame === 'bocciato' || selectedUser.esito_esame === 'non_svolto';
        const isAbilitatoUser = selectedUser.abilitato_ripetizione == 1;

        return (
          <div>
            <div className="d-flex align-items-center mb-3">
                <div className="bg-light rounded-circle d-flex align-items-center justify-content-center me-3" style={{width: '60px', height: '60px'}}><i className="bi bi-person-fill fs-2 text-secondary"></i></div>
                <div><h5 className="mb-0 text-primary">{selectedUser.nome} {selectedUser.cognome}</h5><small className="text-muted">{selectedUser.email || 'Email non disponibile'}</small></div>
            </div>
            <Card className="mb-3 border-0 bg-light">
                <Card.Body>
                    <Row>
                        <Col xs={6} className="mb-2"><small className="text-muted d-block">Luogo di nascita</small><strong>{selectedUser.luogo_nascita || '-'}</strong></Col>
                        <Col xs={6} className="mb-2"><small className="text-muted d-block">Data di nascita</small><strong>{selectedUser.data_nascita ? moment(selectedUser.data_nascita).format('DD/MM/YYYY') : '-'}</strong></Col>
                        <Col xs={6}><small className="text-muted d-block">Data Prenotazione</small><strong>{selectedUser.data_prenotazione ? moment(selectedUser.data_prenotazione).format('DD/MM/YYYY HH:mm') : '-'}</strong></Col>
                        <Col xs={6}><small className="text-muted d-block">Esito Esame</small><strong>{selectedUser.esito_esame ? selectedUser.esito_esame.replace('_', ' ') : 'Non svolto'}</strong>{isAbilitatoUser && isBocciatoUser && (<span className="badge bg-success ms-2" style={{fontSize:'0.7em'}}>Ripetizione Abilitata</span>)}</Col>
                    </Row>
                </Card.Body>
            </Card>
            <div className="row g-3">
                {isBocciatoUser && !isAbilitatoUser && (
                  <div className="col-md-6"> 
                      <div className="card h-100 shadow-sm border-warning" style={{backgroundColor: '#fffcf5'}}> 
                          <div className="card-body d-flex flex-column align-items-center justify-content-center text-center"> 
                              <i className="bi bi-lock-fill fs-1 mb-2 text-warning"></i> 
                              <h6 className="card-title text-warning fw-bold">Gestione Bocciatura</h6> 
                              <Button variant="warning" size="sm" onClick={() => handleAbilitaRipetizione(selectedUser.id_calendario_esame_utente, `${selectedUser.nome} ${selectedUser.cognome}`)} className="mt-1 text-dark fw-bold shadow-sm"> 
                                  <i className="bi bi-unlock-fill me-1"></i> Sblocca e Abilita
                              </Button> 
                          </div> 
                      </div> 
                  </div>
                )}
                <div className="col-md-6"> <div className="card h-100 shadow-sm"> <div className="card-body d-flex flex-column align-items-center justify-content-center text-center"> <i className="bi bi-person-gear fs-1 mb-2 text-primary"></i> <h6 className="card-title">Anagrafica Corsista</h6> <Button variant="outline-primary" size="sm" onClick={handleEditProfileUser} className="mt-2"> <i className="bi bi-pencil-square me-1"></i> Modifica </Button> </div> </div> </div>
                {haPassatoEsameUser && ( <div className="col-md-6"> <div className="card h-100 shadow-sm"> <div className="card-body d-flex flex-column align-items-center justify-content-center text-center"> <i className="bi bi-file-earmark-arrow-down fs-1 mb-2 text-success"></i> <h6 className="card-title">Attestato</h6> <Button variant="outline-success" size="sm" onClick={handleDownloadAttestatoUser} className="mt-2"> <i className="bi bi-printer me-1"></i> Stampa </Button> </div> </div> </div> )}
                <div className="col-md-6"> <div className="card h-100 shadow-sm border-dark"> <div className="card-body d-flex flex-column align-items-center justify-content-center text-center"> <i className="bi bi-envelope-at fs-1 mb-2 text-dark"></i> <h6 className="card-title">Email Prenotazione</h6> <Button variant="outline-dark" size="sm" onClick={handleResendEmail} className="mt-2"> <i className="bi bi-send me-1"></i> Reinvia </Button> </div> </div> </div>
                <div className="col-md-6"> <div className="card h-100 shadow-sm border-warning"> <div className="card-body d-flex flex-column align-items-center justify-content-center text-center"> <i className="bi bi-calendar-x fs-1 mb-2 text-warning"></i> <h6 className="card-title">Annulla Prenotazione</h6> <Button variant="outline-warning" size="sm" onClick={() => setShowConfirmDeleteModal(true)} className="mt-2"> <i className="bi bi-exclamation-triangle me-1"></i> Annulla </Button> </div> </div> </div>
            </div>
          </div>
        );

      case MODAL_TYPES.MANAGE_USERS:
        const userPrenotatoMU = newExam.utenti?.find(u => u.prenotato);
        return (
          <>
            {classe?.corso?.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA ? (
                <div>
                  {userPrenotatoMU ? (
                    <div className="d-flex flex-column align-items-start"><h5>Corsista prenotato: {userPrenotatoMU.nome} {userPrenotatoMU.cognome}</h5></div>
                  ) : (<h5>Nessun corsista prenotato</h5>)}
                </div>
              ) : (
                <div>
                  <h5>Abilita corsisti alla prenotazione per l'esame del {moment(newExam.data).format('DD/MM/YYYY')}</h5>
                  {corsoUtenti.map(user => {
                    const isPrenotato = newExam.utenti?.some(u => u.id_utente === user.id_utente && u.prenotato);
                    return (
                      <div key={user.id_utente} className="d-flex justify-content-between align-items-center mb-2">
                        <div className="form-check">
                          <input type="checkbox" className="form-check-input" id={`user-${user.id_utente}`} checked={isPrenotato || selectedExamUsers.some(u => u.id_utente === user.id_utente)} onChange={() => !isPrenotato && handleUserSelection(user)} disabled={isPrenotato} />
                          <label className="form-check-label" htmlFor={`user-${user.id_utente}`}>{user.nome} {user.cognome} {isPrenotato && <span className="badge bg-success ms-2">Prenotato</span>}</label>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )
            }
          </>
        );

      case MODAL_TYPES.DELETE:
        return (
          <div><p className="fs-5">Sei sicuro di voler eliminare questo esame?</p><p className="text-muted small">L'operazione è irreversibile.</p></div>
        );

      default: return null;
    }
  };

  const getBackPath = () => {
    if (classe?.corso?.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA) {
      return "/gestione-corsi"
    } else {
      return "/gestione-classi"
    }
  }

  if (!classe) {
    return <div>Caricamento...</div>;
  }

  return (
    <div className={`card custom-card w-100 shadow ${isWideScreen ? "p-5" : "px-1 py-3"}`} style={{ minHeight: "700px" }}>
      <div className="container">
        <ComebackArrow path={getBackPath()} />
        <div className="d-flex justify-content-between custom-card-header mb-3">
          <div className="d-flex gap-3 custom-card-title my-2">
            <div className={`custom-icon-container`}>
              {classe?.corso?.immagine_corso ? 
                <img src={classe?.corso?.immagine_corso} className='custom-icon' alt='immagine corso'/> : 
                <i className={`bi custom-icon bi-calendar-event fs-2`}></i>}
            </div>
            <div className="align-self-center">
              <span className="fs-4 d-block">
                <i>
                  <b>
                    <h2>{classe?.corso?.denominazione} - Esami</h2>
                  </b>
                </i>
              </span>
            </div>
          </div>
        </div>
        <div style={{ height: '100vh' }}>
        <CustomCalendar
          events={exams.map(exam => {
          const corsistiPrenotati = exam.utenti?.filter(u => u.prenotato) || [];
            const numeroPrenotati = corsistiPrenotati.length;
            
            const isConcluso = exam.is_concluso == 1 || exam.is_concluso === true;
            const maxParts = (exam.max_parts && exam.max_parts > 0) ? exam.max_parts : 1; 
            const countdownText = examCountdowns[exam.id_calendario_esame];
            
            let headerText = null; 
            const isGruppo = (exam.is_multiplo == 1) || (maxParts > 1);

            if (isGruppo) {
               headerText = `Esame di gruppo (${numeroPrenotati}/${maxParts})`;
            } else if (classe?.corso?.modalita_erogazione === TIPO_CORSO.TELEMATICA_SINCRONA) {
               headerText = `Esame Sincrono`; 
            }

            let eventContent = null;

            if (numeroPrenotati === 0) {
              eventContent = (
                <div className="d-flex flex-column h-100 justify-content-start">
                  {headerText && <div style={{fontSize: '0.85rem', fontWeight: 'bold', marginBottom: '2px'}}>{headerText}</div>}
                  <div style={{ color: '#54b954ff', fontWeight: 'bold', marginTop: 'auto' }}> 
                    <i className="bi bi-check-circle me-1"></i>
                    Disponibile
                  </div>
                </div>
              );
            } else {
              const listaNomi = corsistiPrenotati.map(user => {
                let statusBadge = null;
                const esito = user.esito_esame; 
                const presenza = user.presenza;

                if (presenza === 'assente') {
                    statusBadge = <span className="badge bg-danger ms-1" style={{fontSize: '0.7em'}}>Assente</span>;
                } else if (esito === 'promosso') {
                    statusBadge = <span className="badge bg-success ms-1" style={{fontSize: '0.7em'}}>Promosso</span>;
                } else if (esito === 'bocciato') {
                    statusBadge = <span className="badge bg-warning text-dark ms-1" style={{fontSize: '0.7em'}}>Bocciato</span>;
                } else if (isConcluso && (!esito || esito === 'non_svolto') && presenza !== 'presente') {
                    statusBadge = <span className="badge text-dark bg-secondary ms-1" style={{fontSize: '0.7em'}}>Non Presentato</span>;
                }

                return (
                  <div key={user.id_utente} 
                    onClick={(e) => {
                        if (isGruppo) {
                            handleUserClick(e, user, exam);
                        }
                    }}
                    className={isGruppo ? "user-list-item" : ""}
                    style={{ 
                        fontSize: '0.85rem', 
                        whiteSpace: 'nowrap', 
                        overflow: 'hidden', 
                        textOverflow: 'ellipsis',
                        cursor: isGruppo ? 'pointer' : 'inherit', 
                        padding: '2px 4px', 
                        borderRadius: '4px'
                    }}
                    onMouseOver={(e) => { if(isGruppo) e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.1)'; }} 
                    onMouseOut={(e) => { if(isGruppo) e.currentTarget.style.backgroundColor = 'transparent'; }}>
                    <i className="bi bi-person-fill me-1"></i>
                    {user.cognome} {user.nome}
                    {statusBadge}
                  </div>
                );
              });

              let actionElement = null;

              if (isConcluso) {
                 actionElement = <div className="mt-1 badge bg-dark text-white"><i className="bi bi-check-all me-1"></i>Terminato</div>;
              } 
              else if (countdownText === 'INIZIATO') {
                actionElement = (
                      <Button
                        variant="light" 
                        size="sm"
                        className="mt-2 text-success fw-bold w-100"
                        onClick={(e) => {
                          e.stopPropagation();
                          enterJoinRoom(exam.id_calendario_esame, exam);
                        }}
                      >
                        <i className="bi bi-camera-video-fill me-2"></i>
                        Accedi
                      </Button>
                    );
              } else if (countdownText) {
                actionElement = <div className="mt-1 badge bg-light text-dark">{countdownText}</div>;
              }

              eventContent = (
                <div className="d-flex flex-column h-100">
                  {headerText && (
                    <div className="border-bottom pb-1 mb-1" style={{fontSize: '0.9rem'}}>
                        <strong>{headerText}</strong>
                    </div>
                  )}
                  
                  <div className="flex-grow-1" style={{ overflowY: 'auto', minHeight: '20px' }}>
                    {listaNomi}
                  </div>

                  <div className="mt-auto pt-2">
                    {actionElement}
                  </div>
                </div>
              );
            }

            return {
              id_calendario_esame: exam.id_calendario_esame,
              ...exam, 
              title: eventContent, 
              start: new Date(`${exam?.data}T${exam?.ora_inizio}`),
              end: new Date(`${exam?.data}T${exam?.ora_fine}`),
              allDay: false,
              color: isConcluso ? '#6c757d' : (numeroPrenotati > 0 ? '#198754' : '#dc3545') 
            };
          })}
          availableViews={["month", "agenda"]}
          onSelectSlot={handleSelectSlot}
          onSelectEvent={handleSelectEvent}
          minDate={minDate}
          isLoading={loadingStateEsami.getEsamiByIdClasse}
        />
        </div>
        <CustomModal
          show={showModal}
          onHide={handleCloseModal}
          headerText={<h5 className="form-control-static">{formatDate(newExam.data)}</h5>}
          size={modalMode === MODAL_TYPES.DELETE || modalMode === MODAL_TYPES.EDIT || modalMode === MODAL_TYPES.MANAGE_USERS || modalMode === MODAL_TYPES.NEW ? "md" : "lg"}
          btnText={
            modalMode === MODAL_TYPES.DELETE
              ? "Elimina Esame" 
              : (modalMode === MODAL_TYPES.MANAGE_USERS && classe?.corso?.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA && userPrenotato)
                ? "Annulla Prenotazione"
                : "Salva modifiche"
          }
          variant={modalMode === MODAL_TYPES.DELETE ? "danger" : "primary"}
          body={renderModalBody()}
          btnCancelText={'Chiudi'}
          closeButton={true}
          isLoading={loadingStateEsami.isLoadingEsameCreating || loadingStateEsami.isLoadingEsameUpdate || loadingStateEsamiUtenti.isLoadingEsameUtenteCreating || loadingStateEsamiUtenti.isLoadingEsameUtenteUpdate || loadingStateEsami.isLoadingEsameDelete}
          onUndoChanges={handleCloseModal}
          onSave={
            modalMode === MODAL_TYPES.DELETE
              ? handleDeleteExam 
              : (modalMode === MODAL_TYPES.MANAGE_USERS && classe?.corso?.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA && userPrenotato)
                ? () => setShowConfirmDeleteModal(true)
                : (modalMode === MODAL_TYPES.NEW || modalMode === MODAL_TYPES.EDIT)
                  ? handleSaveExam
                  : modalMode === MODAL_TYPES.MANAGE_USERS
                    ? handleSaveUserSelection
                    : null
          }
          hideSaveBtn={
            modalMode === MODAL_TYPES.MANAGE_USERS &&
            classe?.corso?.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA &&
            !userPrenotato
          }
          hideButtons={
            modalMode !== MODAL_TYPES.NEW && 
            modalMode !== MODAL_TYPES.EDIT && 
            modalMode !== MODAL_TYPES.MANAGE_USERS && 
            modalMode !== MODAL_TYPES.DELETE 
          }
        />
        <CustomModal
          show={showConfirmDeleteModal}
          onHide={() => setShowConfirmDeleteModal(false)}
          headerText={<h5 className="form-control-static">Conferma Annullamento</h5>}
          size="md"
          body={
            <p>Sei sicuro di voler annullare la prenotazione di <b>{userPrenotato?.nome} {userPrenotato?.cognome}</b>?</p>
          }
          btnText={"Conferma Annullamento"}
          btnCancelText={"Chiudi"}
          onUndoChanges={() => setShowConfirmDeleteModal(false)}
          onSave={handleConfirmCancelUserBooking}
          isLoading={loadingStateEsamiUtenti?.isLoadingEsameUtenteDelete}
        />
         <CustomModal
            show={modalStateAttestati.showSelectRecipientModal}
            onHide={handleCloseSelectRecipientModal}
            headerText="Stampa Busta - Seleziona Destinatario"
            size={"sm"}
            btnText={"Salva e Stampa"}
            body={
                <SelectRecipientModal
                    show={modalStateAttestati.showSelectRecipientModal}
                    attestatoData={userForEnvelopePrint}
                    onSubjectChange={handleSubjectChangeForPrint}
                    currentSoggetto={selectedSoggettoForPrint}
                />
            }
            isLoading={loadingStateAttestati.isLoadingUpdateSpedizione || loadingStateAttestati.isPrintingEnvelope}
            onUndoChanges={handleCloseSelectRecipientModal}
            onSave={handleConfirmRecipientAndPrint}
            disableSave={selectedSoggettoForPrint === 'agenzia' && !userForEnvelopePrint?.id_agenzia}
        />
        <CustomModal
            show={modalStateUtenti.showModalUpdateUtente} 
            onHide={handleCloseEditUserModal} 
            headerText={`Aggiorna informazioni - ${selectedUtenteForEdit?.nome || ''} ${selectedUtenteForEdit?.cognome || ''}`}
            size={"lg"}
            hideSaveBtn={true} 
            footerStyle={"d-none"} 
            body={
                selectedUtenteForEdit ? (
                    <InputUserinfo
                        userData={selectedUtenteForEdit} 
                        isUpdateUserFromModal={true}
                        onHide={handleCloseEditUserModal} 
                    />
                ) : <p>Caricamento dati utente...</p> 
            }
            closeButton={true} 
            onUndoChanges={handleCloseEditUserModal} 
        />
      </div>
    </div>
  );
}